export default class XtIBE 
{
    constructor ()
    {
        this.ease = {}
        this.lastResizeHeight = 0

        const a = (navigator.userAgent||navigator.vendor||window.opera)
        this.isMobile = (navigator.userAgentData && navigator.userAgentData.mobile) || /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))

        this.send({
            action: 'navigate'
        })

        this.resizeObserver = new ResizeObserver(entries => this.resize())
        document.addEventListener('DOMContentLoaded', event => {
            this.resizeObserver.observe(document.body)
        })
    }

    easeSetup (picker, headRenderer)
    {
        picker.on('show', e => {
            IBE.easeShow(picker, true)
        })

        picker.on('preselect', e => {
            if (headRenderer) {
                picker.options.header = headRenderer(e.detail.start)
            }
        })

        picker.on('select', e => {
            if (headRenderer) {
                picker.options.header = headRenderer(e.detail.start, e.detail.end)
            }
        })

        picker.on('view', e => {
            if (headRenderer && e.detail.view === 'Main') {
                picker.options.header = headRenderer(picker.getStartDate(), picker.getEndDate())
            }
        })
    }

    formatDpDate (date)
    {
        return new Date(date.toUTCString()).toLocaleDateString(document.documentElement.lang.substring(0, 2), {
            year: '2-digit',
            month: 'short',
            day: 'numeric',
            weekday: 'short'
        })
    }

    easeShow (picker, allowCenter)
    {
        const { container, wrapper } = picker.ui
        const { offsetWidth, offsetHeight } = container
        const { top, left } = wrapper.getBoundingClientRect()
        const elementWidth = picker.options.element.offsetWidth
        const elementHeight = picker.options.element.offsetHeight

        // width - horizontal
        if (window.innerWidth < (left + offsetWidth)) {
            // out of bound
            if (0 < (left - offsetWidth + elementWidth)) {
                // position right okay
                container.classList.remove('h-center')
                container.classList.add('h-right')
                container.style.left = elementWidth + 'px'
            } else if (allowCenter) {
                container.classList.add('h-center')
                container.classList.remove('h-right')
                container.style.left = (elementWidth / 2) + 'px'
            }
        } else {
            container.classList.remove('h-center')
            container.classList.remove('h-right')
            container.style.left = 0
        }
        
        // height - vertical
        if (window.innerHeight < (top + offsetHeight)) {
            // out of bound
            if (0 < (top - offsetHeight)) {
                // position top okay
                container.classList.remove('v-center')
                container.classList.add('v-top')
                container.style.top = -elementHeight + 'px'
            } else if (allowCenter) {
                container.classList.add('v-center')
                container.classList.remove('v-top')

                const topPosition = (elementHeight + offsetHeight) / 2

                if (topPosition < top) {
                    container.style.top = -(elementHeight / 2) + 'px'
                } else {
                    container.style.top = (topPosition - top) + 'px'
                }
            }
        } else {
            container.classList.remove('v-center')
            container.classList.remove('v-top')
            container.style.top = 0
        }
    }

    scrollToElement (element)
    {
        element.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
        });
        this.scrollTo(element.getBoundingClientRect().top)
    }

    scrollTo (position)
    {
        this.send({
            action: 'scroll',
            top: position
        })
    }

    send (data)
    {
        if (window.top !== window.self) {
            window.top.postMessage(data, '*')
        }
    }

    resize (el)
    {
        if (this.lastResizeHeight != document.body.offsetHeight) {
            this.lastResizeHeight = document.body.offsetHeight
            this.send({
                action: 'resize',
                height: document.body.offsetHeight
            })
        }
        if (el) {
            this.scrollToElement(el)
        }
    }

    isIframe () 
    {
        return window.top !== window.self
    }

    checkNoIframe ()
    {
        if (this.isIframe()) {
            window.top.location = window.location
        }
    }

    forceIframe (url) 
    {
        if (!this.isIframe() && !this.isSafari()) {
            let redirectTo = new URL(url)
            redirectTo.searchParams.append('url', window.location.href)
            window.location = redirectTo
        }
    }

    checkSafari ()
    {
        if (this.isSafari()) {
            window.top.location = window.location
        }
    }

    isSafari ()
    {
        try {
            if (navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
                navigator.userAgent &&
                navigator.userAgent.indexOf('CriOS') === -1 &&
                navigator.userAgent.indexOf('FxiOS') === -1 && 
                this.isIframe()
            ) {
                const topUrl = new URL(window.location.ancestorOrigins[0]);
                return window.location.host.indexOf(topUrl.host.replace('www.', '')) === -1;
            }
        } catch (err) {
            return true
        }
    }

	checkDarkmode ()
	{
		const getStoredTheme = () => localStorage.getItem('theme')
		const setStoredTheme = theme => localStorage.setItem('theme', theme)
	  
		const getPreferredTheme = () => {
			const storedTheme = getStoredTheme()
			if (storedTheme) {
				return storedTheme
			}

			return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
		}
	  
		const setTheme = theme => {
			if (theme === 'auto') {
				document.documentElement.setAttribute('data-bs-theme', (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'))
			} else {
				document.documentElement.setAttribute('data-bs-theme', theme)
				setStoredTheme(theme)
			}
		}

		const showActiveTheme = theme => {
			const icon = theme === 'dark' ? 'fa-solid fa-moon' : 'fa-regular fa-sun'
			const btn = document.querySelector('.xtc-general-navigation .xtc-theme-switcher')
			btn.innerHTML = `<i class="${icon}"></i>`
		}
	  
		setTheme(getPreferredTheme())

		window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
			const storedTheme = getStoredTheme()
			if (storedTheme !== 'light' && storedTheme !== 'dark') {
				setTheme(getPreferredTheme())
			}
		})
		window.addEventListener('DOMContentLoaded', () => {
			showActiveTheme(getPreferredTheme())

			document.querySelectorAll('.xtc-theme-switcher')
				.forEach(toggle => {
					toggle.addEventListener('click', () => {
						const theme = getStoredTheme() === 'dark' ? 'light' : 'dark'
						setTheme(theme)
						showActiveTheme(theme)
					})
				})
		})
	}
}